import { ITFormControlType } from './form-control-base';

export interface FormValueModel {
	[key: string]: ITFormControlType;
}
